// utils.service.ts
// Global methods


export default class UtilsService
{
  // @ts-ignore
  public static consoledev(...args) {
    // Only run in development mode
    if (process.env.NODE_ENV === 'development') {
      console.log.apply(console, args);
    }
  }

  /**
   * Convert a number to a currency for display. Returns original amount if not a number.
   * @param amount {number} Dollar fiture to format
   * @returns 
   */
  public static formatCurrency(amount: string): string {
    if (amount == null || amount?.length === 0) {
      return amount;
    }

    // Remove $ and , before conversion
    amount = amount.replace('$', '').replace(',', '');
    const number = parseFloat(amount);

    // console.log('format', amount, number);
    if (isNaN(number)) {
      return amount;
    }

    const formatted = number.toLocaleString('en-US', {style: 'currency', currency: 'USD'});

    return formatted;
  }

}
